import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagPL = function FlagPL() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "poland"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M179.787572,89.8420959 C179.787608,89.8752924 179.787626,89.9084931 179.787626,89.9416981 C179.787626,139.615129 139.577323,179.883396 89.9753957,179.883396 C40.3734681,179.883396 0.163165468,139.615129 0.163165468,89.9416981 C0.163165468,89.9084931 0.163183435,89.8752924 0.163219362,89.8420959 L179.787576,89.8420959 L179.787576,89.8420959 L179.787572,89.8420959 L179.787572,89.8420959 L179.787572,89.8420959 Z",
    id: "red",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M89.9753957,0 C40.4066253,0 0.21692798,40.2144496 0.163219362,89.8420959 L179.787576,89.8420959 C179.733863,40.2144496 139.544166,0 89.9753957,0 Z",
    id: "white",
    fill: "#FFFFFF"
  })));
};

FlagPL.displayName = 'FlagPL';
export default withFlagWrapper(FlagPL);
//# sourceMappingURL=index.js.map